// extracted by mini-css-extract-plugin
export default {"container":"AdminOngoing_container__oJMiz","left":"AdminOngoing_left__2uTLN","right":"AdminOngoing_right__cA6nv"};